import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { isChainSupported } from '@emberswap/emberswap-sdk2/dist/functions'
import { useCallback /* , useMemo*/ } from 'react'
import { /* useDispatch, */ useDispatch, useSelector } from 'react-redux'

import { updateChainId as updatechainid, updateConnect } from './actions'
import { Theme, WithApplicationState } from './reducer'
// import { updateTheme, updateLanguage } from './actions'
// import {  /* addPopup,*/ ApplicationModal, /* PopupContent, removePopup,*/ setModal } from './actions'


type useSessionChainIdReturn = [
  ChainId,
  {
    updateChainId(payload: ChainId): void
  }
]
type UseSessionChainId = () => useSessionChainIdReturn
export const useSessionChainId: UseSessionChainId = () => {
  const dispatch = useDispatch()
  const chainId = useSelector((state: WithApplicationState) => state.application.chainId)
  const updateChainId = useCallback(
    (chainId: ChainId) => {
      isChainSupported(chainId) && 
      dispatch(updatechainid({ chainId }))
    },
    [dispatch]
  )
  return [chainId, { updateChainId }]
}

/**
 * @return {Theme}
 */
export function useTheme(): Theme {
  return useSelector((state: WithApplicationState) => state.application.theme)
}
/**
 * @return {Theme}
 */
export function useLanguage(): string {
  return useSelector((state: WithApplicationState) => state.application.language)
}
/**
 * @return { number | undefined}
 */
export function useBlockNumber(): number | undefined {
  const [chainId] = useSessionChainId()
  return useSelector((state: WithApplicationState) => state.application.blockNumber[chainId])
}

type UseConnectedReturn = [
  boolean,
  {
    updateConnection(payload: boolean): void
  }
]
type UseConnceted = () => UseConnectedReturn
/**
 * @return { (boolean | { void })[]}
 */
export const useIsConnected: UseConnceted = () => {
  const isAllowedConnect = useSelector((state: WithApplicationState) => state.application.connected)

  const dispatch = useDispatch()

  const updateConnection = useCallback(
    (connect: boolean) => {
      dispatch(updateConnect({ connect }))
    },
    [dispatch]
  )

  return [isAllowedConnect, { updateConnection }]
}
// /**
//  * @return {void} toggle settings modal
//  */
// export function useSettingsModalToggle(): () => void {
//   return useToggleModal(ApplicationModal.SETTINGS)
// }
//
// /**
//  * @return {boolean} true if settings modal open
//  */
// export function useSettingsActive(): boolean {
//   return useModalOpen(ApplicationModal.SETTINGS)
// }
//
/**
 * @return {void} close modals
 */
// export function useCloseModal(): () => void {
//   const dispatch = useDispatch<AppDispatch>()
//   return useCallback(() => dispatch(setModal(null)), [dispatch])
// }
// export function useTokenStatsModalToggle(token): () => void {
//   return useToggleModal(token.symbol == 'EMBER' ? ApplicationModal.EMBER_STATS : ApplicationModal.BCH_STATS)
// }
//
// export function useYieldDetailsModalToggle(): () => void {
//   return useToggleModal(ApplicationModal.YIELD_DETAILS)
// }
//
// export function useChainModalToggle(): () => void {
//   return useToggleModal(ApplicationModal.CHAIN)
// }
//
// export function useNetworkModalToggle(): () => void {
//   return useToggleModal(ApplicationModal.NETWORK)
// }
//
// export function useToggleSettingsMenu(): () => void {
//   return useToggleModal(ApplicationModal.SETTINGS)
// }
//
// export function useToggleShowClaimPopup(): () => void {
//   return useToggleModal(ApplicationModal.CLAIM_POPUP)
// }
//
// export function useToggleSelfClaimModal(): () => void {
//   return useToggleModal(ApplicationModal.SELF_CLAIM)
// }
//
// export function useToggleDelegateModal(): () => void {
//   return useToggleModal(ApplicationModal.DELEGATE)
// }
//
// export function useToggleVoteModal(): () => void {
//   return useToggleModal(ApplicationModal.VOTE)
// }
//
// // returns a function that allows adding a popup
// export function useAddPopup(): (content: PopupContent, key?: string) => void {
//   const dispatch = useDispatch()
//
//   return useCallback(
//     (content: PopupContent, key?: string) => {
//       dispatch(addPopup({ content, key }))
//     },
//     [dispatch]
//   )
// }
//
// // returns a function that allows removing a popup via its key
// export function useRemovePopup(): (key: string) => void {
//   const dispatch = useDispatch()
//   return useCallback(
//     (key: string) => {
//       dispatch(removePopup({ key }))
//     },
//     [dispatch]
//   )
// }
//
// // get the list of active popups
// export function useActivePopups(): AppState['application']['popupList'] {
//   const list = useSelector((state: AppState) => state.application.popupList)
//   return useMemo(() => list.filter((item) => item.show), [list])
// }
//
// export function useKashiApprovalPending(): string {
//   return useSelector((state: AppState) => state.application.kashiApprovalPending)
// }
//
//
// /**
//  * @param {ApplicationModal} modal
//  * @return {boolean}
//  */
// function useModalOpen(modal: ApplicationModal): boolean {
//   const openModal = useSelector((state: AppState) => state.application.modal)
//   return openModal === modal
// }
// /**
//  * @param {ApplicationModal} modal
//  * @return {void}
//  */
// function useToggleModal(modal: ApplicationModal): () => void {
//   const open = useModalOpen(modal)
//   const dispatch = useDispatch<AppDispatch>()
//   return useCallback(() => dispatch(setModal(open ? null : modal)), [dispatch, modal, open])
// }
